
import orderBy from 'lodash/orderBy'
import intersection from 'lodash/intersection'

const typeOf = o => Object.prototype.toString.call(o).slice(8, -1).toLowerCase()
const purify = o => JSON.parse(JSON.stringify(o)) // purify data

/**
 * mockData - simulate Ajax request and respond
 * @param   {Object} query
 * @resolve {Object}
 */
export default function mockData(query, rows, columns, data) {
  query = purify(query)
  const { limit = 10, offset = 0, sort = '', order = '' } = query

  const filterables = columns.filter(column => column.filterable == true)
  columns = intersection(filterables.map(column => column.field), Object.keys(query).filter((query_key) => query[query_key] !== ''))

  columns.forEach(field => {

    const filterable_field = filterables.find(filterable => filterable.field == field);

    let items = []
    let list_type = false
    if (filterable_field.lists != undefined) {
      let lists = data[filterable_field.lists]
      items = lists.filter(item => item.label.toLowerCase().includes(query[field].toLowerCase())).map(item => item.id)
      list_type = true
    }

    switch (list_type ? 'list' : typeOf(query[field])) {
      case 'list':
        rows = rows.filter(row => {
          if (typeof row[field] === 'string') {
            return row[field].toString().toLowerCase().includes(query[field].toLowerCase())
          }
          return items.includes(row[field])
        })
        break
      case 'array':
        rows = rows.filter(row => query[field].includes(row[field]))
        break
      case 'string':
        // rows = rows.filter(row => query[field].includes(row[field]))
        rows = rows.filter(row => row[field].toString().toLowerCase().includes(query[field].toLowerCase()))
        break
      default:
        // nothing to do
        break
    }
  })

  if (sort) {
    rows = orderBy(rows, sort, order)
  }

  const res = {
    // rows: rows,
    rows: rows.slice(offset, offset + limit),
    total: rows.length,
    filterApply: true
    // filterApply: columns.length || sort ? true : false
  }

  // const consoleGroupName = 'Mock data - ' + moment().format('YYYY-MM-DD HH:mm:ss')
  // setTimeout(() => {
  //   console.group(consoleGroupName)
  //   console.info('Receive:', query)
  //   console.info('Respond:', res)
  //   console.groupEnd(consoleGroupName)
  // }, 0)
  return Promise.resolve(res)
  // return Promise.resolve(purify(res))
}
